module.exports = __webpack_public_path__ + "img/orange-theory-logo.d80a92f.png";